const AVAILABLE_MARKETS = {
  AUT: "Austria",
  BEL: "Belgium",
  CZE: "Czech Republic",
  DNK: "Denmark",
  FIN: "Finland",
  FRA: "France",
  DEU: "Germany",
  GRC: "Greece",
  HUN: "Hungary",
  IRL: "Ireland",
  ITA: "Italy",
  NLD: "Netherlands",
  NOR: "Norway",
  POL: "Poland",
  PRT: "Portugal",
  ROU: "Romania",
  ESP: "Spain",
  CHE: "Switzerland",
  GBR: "United Kingdom",
};

export { AVAILABLE_MARKETS };
